import { orchestrator } from 'satcheljs';
import {
    popOutFullCompose,
    prepareEvent,
    closeComposeForm,
    updateSidePaneType,
    setViewType,
} from 'owa-calendar-compose-form-actions';
import canNavigateAway from '../utils/canNavigateAway';
import {
    getComposeEvent,
    getOriginalEvent,
    getFullComposeViewState,
    getMetricsInfo,
} from 'owa-calendar-compose-store-manager';
import { onCloseFullCompose } from 'owa-calendar-compose-form-store';
import { updateCollabSpace } from '../utils/updateCollabSpace';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import { FullComposeFormViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import clearDomProperties from 'owa-editor-docking-plugin/lib/actions/clearDomProperties';
import { isFeatureEnabled } from 'owa-feature-flags';
import addTab from 'owa-tab-store/lib/utils/addTab';
import { TabType } from 'owa-tab-store';
import { addPopoutV2 } from 'owa-popout-v2';
import { FluidOwaSource, isFluidEnabledForSource } from 'owa-fluid-validations';
import {
    tryStartFullComposePerfDatapoint,
    OpenCalendarFullComposeActionType,
} from 'owa-calendar-compose-form-utils';

const CALENDAR_POPOUT_WINDOW_SIZE = {
    width: 1095,
    height: 640,
};

orchestrator(popOutFullCompose, async actionMessage => {
    const { formId, entrySource } = actionMessage;

    if (!(await canNavigateAway(formId))) {
        return;
    }

    prepareEvent(formId);

    // Update the calendar event to set the collaborative space from the collaborative space store
    await updateCollabSpace(formId);

    const viewState = getFullComposeViewState(formId);
    const event = getComposeEvent(formId);
    const originalEvent = getOriginalEvent(formId);

    if (viewState.currentSidePaneType === SidePaneType.Addins) {
        // Ensure addins are closed as the adapter will be reinitialized
        // for the new form UI in the popout
        updateSidePaneType(formId, SidePaneType.None);
    }

    if (viewState.docking) {
        clearDomProperties(viewState.docking);
    }

    const actionType = isFeatureEnabled('cal-fullcompose-popout-projection')
        ? OpenCalendarFullComposeActionType.ProjectionPopout
        : OpenCalendarFullComposeActionType.DeeplinkPopout;

    await tryStartFullComposePerfDatapoint(
        actionType,
        formId,
        true /* bundleAlreadyLoaded */,
        entrySource
    );

    if (actionType == OpenCalendarFullComposeActionType.ProjectionPopout) {
        // Trigger the module to close the current modal
        onCloseFullCompose(
            getMetricsInfo(formId).quickComposeEntrySource ?? null,
            formId,
            viewState.viewType,
            true /* shouldClearPreview */
        );

        const tabId = addTab(
            TabType.CalendarCompose,
            false /* isShown */,
            false /* makeActive */,
            formId
        );

        setViewType(formId, FullComposeFormViewType.ProjectionPopOut);

        addPopoutV2(
            'calendar',
            'compose',
            {
                projectionTabId: tabId,
            },
            CALENDAR_POPOUT_WINDOW_SIZE
        );
    } else {
        closeComposeForm(
            formId,
            event.IsMeeting,
            false /* shouldResetComposeStore */,
            true /* shouldClosePopOutWindow */
        );

        addPopoutV2(
            'calendar',
            'compose',
            {
                priorStateConfig: {
                    viewState: viewState,
                    event: event,
                    originalEvent: originalEvent,
                    composeEntrySource: entrySource,
                },
                includeFluidOnPopout: isFluidEnabledForSource(FluidOwaSource.CalendarCompose),
            },
            CALENDAR_POPOUT_WINDOW_SIZE
        );
    }
});
